import { YesNoPromptCommand } from "appworks/commands/error/yes-no-prompt-command";
import { PromptContentSubcomponent } from "appworks/components/prompt/prompt-content-subcomponent";
import { Layers } from "appworks/graphics/layers/layers";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { Contract } from "appworks/utils/contracts/contract";

export function SoundPromptCommand(messageId: string = "sound_prompt", showLoadScreen: boolean = false, remember: boolean = false) {
    return new Contract<boolean>((resolve) => {

        if (remember && Services.get(SoundService).isMutePreferenceSet()) {
            if (!Services.get(SoundService).getMuted()) {
                Services.get(SoundService).unmute();
            }
            resolve(Services.get(SoundService).getMuted());
            return;
        }

        const prompt = new PromptContentSubcomponent(["yes_no"], Infinity, Layers.get("Alerts"));

        prompt.setText("body", Services.get(TranslationsService).get(messageId));

        YesNoPromptCommand(
            prompt,
            () => {
                if (showLoadScreen) {
                    Services.get(SoundService).unmuteLoadScreen().then(() => {
                        resolve(true);
                    });
                } else {
                    Services.get(SoundService).unmute();
                    resolve(true);
                }

            },
            () => {
                Services.get(SoundService).mute();
                resolve(false);
            }
        ).execute();
    });
}
